import { createSignal } from 'solid-js'

import { translate } from '../i18n'
import { dispatchAccountAction } from '../runtimeBridge'
import { accountState } from './accountStore'

const [isSyncKeyEditModalOpen, setSyncKeyEditModalOpen] = createSignal(false)
const [syncKeyInput, setSyncKeyInputValue] = createSignal('')
const [syncKeyEditError, setSyncKeyEditError] = createSignal('')

/**
 * Opens the sync key edit modal pre-filled with the active key.
 */
export function openSyncKeyEditModal() {
   setSyncKeyInputValue(accountState().userId)
   setSyncKeyEditError('')
   setSyncKeyEditModalOpen(true)
}

/**
 * Closes the sync key edit modal and clears its input and error.
 */
export function closeSyncKeyEditModal() {
   setSyncKeyEditModalOpen(false)
   setSyncKeyInputValue('')
   setSyncKeyEditError('')
}

/**
 * Sets the sync key input value, clearing any error.
 *
 * @param value - The raw input value.
 */
export function setSyncKeyInput(value: string) {
   setSyncKeyInputValue(value)
   setSyncKeyEditError('')
}

/**
 * Saves the edited key: a different key switches this device to the data saved under
 * it; an unchanged key just closes the modal.
 */
export function saveSyncKeyEdit() {
   const trimmed = syncKeyInput().trim()
   if (!trimmed) {
      setSyncKeyEditError(translate('Enter a valid synchronization key.'))
      return
   }
   const changed = trimmed !== accountState().userId
   closeSyncKeyEditModal()
   if (changed) {
      dispatchAccountAction({ action: 'enter-sync-key', syncKey: trimmed })
   }
}

/**
 * Stops syncing on this device after confirmation, keeping local and cloud data.
 */
export function stopSyncFromEditModal() {
   const confirmed = window.confirm(
      translate(
         'Stop syncing on this device? Your data stays here and in the cloud under this key. Keep a copy of the key if you want to reconnect later.',
      ),
   )
   if (!confirmed) {
      return
   }
   closeSyncKeyEditModal()
   dispatchAccountAction({ action: 'stop-sync' })
}

export { isSyncKeyEditModalOpen, syncKeyEditError, syncKeyInput }
